const initialState = {
	data: [],
	total: 0,
	params: {},
}

const fraudfpidblacklist = (state = initialState, action) => {
	switch (action.type) {
		case 'FRAUDFPIDBLACKLIST_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'FRAUDFPIDBLACKLIST_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'FRAUDFPIDBLACKLIST_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		default:
			return state
	}
}

export default fraudfpidblacklist
